import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { Scene } from 'src/app/models/Scene';
import { ProjectHeatmapService } from 'src/app/services/project-heatmap.service';

@Component({
  selector: 'app-heatmap-modal',
  templateUrl: './heatmap-modal.page.html',
  styleUrls: ['./heatmap-modal.page.scss'],
})
export class HeatmapModalPage implements OnInit {

  public scenes: Scene[] = [];
  public cameraTracking: any[] = [];
  public lookedAtMedia: any[] = [];
  public projectMedia: AssetInScene[] = [];
  public currentSceneMedia: any[] = [];
  public sceneSelected: boolean = false;
  public noAssets: boolean = false;
  public currentSceneIndex: 0;

  constructor(
    public modalController: ModalController,
    public projectHeatmapService: ProjectHeatmapService
  ) { }

  ngOnInit() {
  }

  closeModal() {
    this.modalController.dismiss();
  }

  goToScene(i) {
    this.sceneSelected = true;
    this.currentSceneIndex = i;
  }

  getCurrentSceneCameraTracking() {
    return this.cameraTracking.filter(x => parseInt(x["scene-id"]) == this.scenes[this.currentSceneIndex].sceneId);
  }

  getCurrentSceneMedia() {
    var assets = this.projectMedia.filter(x => x.sceneAssetRelation.sceneId == this.scenes[this.currentSceneIndex].sceneId);
    if (assets.length == 0) {
      this.noAssets = true;
    }
    else {
      this.noAssets = false;
    }
    return assets;
  }
}
